import { useTranslation, Trans } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { titleProps } from '../common/helpers/title-props';

export function LiberisNoRepresentativeDataTitle() {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: { xxl: '70%' } }}>
      <Typography component="h2" {...titleProps} sx={{ marginBottom: '32px' }}>
        <Typography {...titleProps}>
          {t('welcomePage.loanApplicationPossible.liberis.noRepresentativeData.title')}
        </Typography>
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography fontSize={20} lineHeight={'24px'}>
          <Trans
            i18nKey="welcomePage.loanApplicationPossible.liberis.noRepresentativeData.subtitle"
            components={[<b />]}
          />
        </Typography>
      </Box>
    </Box>
  );
}
